// Live Search functionality and styling
jQuery(document).ready(function ($) {
    let interval;
    $('.wp-block-search__input').on("keyup", function (e) {
        if (e.target.value.length > 2 && !interval) {
            if (!$('search-form__submit--icon').length) {
                $('<i id="search-form__submit--icon" class="far fa-search search-form__submit--icon" onClick="this.parentNode.parentNode.submit();"></i>').insertBefore('#wp-block-search__input-1')
            }
            if (!$('search-form__clear--icon').length) {
                $('<i id="search-form__clear--icon" class="far fa-times search-form__clear--icon" onclick="this.previousElementSibling.setAttribute(\'value\', \'\'); this.previousElementSibling.value = \'\';"></i>').insertAfter('#wp-block-search__input-1')
            }
            $('.wp-block-search__button').attr("style", "display:none")
            clearInterval(interval)
            $('.wp-block-search__input').attr("style", "border-bottom-left-radius: 0; border-bottom-right-radius: 0; padding-right: 2rem;")
            interval = setInterval(function () {
                if ($('.searchwp-live-search-results-showing').is(":visible")) {
                    $('.wp-block-search__input').attr("style", "border-bottom-left-radius: 0; border-bottom-right-radius: 0; border-bottom: 0; padding-right: 2rem;")
                    $('.wp-block-search__button').attr("style", "display:none")
                } else {
                    $('.wp-block-search__input').removeAttr("style")
                    $('.wp-block-search__button').removeAttr("style")
                    $('#search-form__submit--icon').remove()
                    $('#search-form__clear--icon').remove()
                    clearInterval(interval)
                    interval = undefined;
                }
            }, 10)
        }
    })
})

